const thingList = [
  {
    type: "Hardware",
    subCategory: "Computer",
    name: "M1 Macbook Air 2020",
    spec: "M1 Chip. 8GB RAM. 256GB SSD.",
    text: "First ever Macbook and I have to say the M1 chip has made me a fan!",
  },
  {
    type: "Hardware",
    subCategory: "Computer",
    name: "Custom PC",
    spec: "Ryzen 5 3600@3.6Ghz. 16GB RAM. 512GB SSD. AMD RX570.",
    text: "First ever custom PC. Built from scratch and installed Arch Linux right away. Next custom built will be an SFF 10/10.",
  },
  {
    type: "Hardware",
    subCategory: "Mobile",
    name: "Iphone 12",
    spec: "4GB RAM. 128GB Storage. iOS.",
    text: "I had always wanted a device that would be reliable, be it boring. My last phone (OnePlus 8) was very exciting with it's display and everything but it was very unreliable with stutters and such. Nothing like that on this one.",
  },
  {
    type: "Hardware",
    subCategory: "Keyboard",
    name: "Akko 3068",
    spec: "65% Mech. Cherry MX Blue Switches. Stock Keycaps.",
  },
  {
    type: "Hardware",
    subCategory: "Mice",
    name: "Logitech G304",
    spec: "-",
  },
  {
    type: "Hardware",
    subCategory: "Watch",
    name: "Apple Watch Series 7",
    spec: "41mm. Blue.",
  },
  {
    type: "Hardware",
    subCategory: "IEM",
    name: "Blon BL-03",
    spec: "IEMs with 10mm dynamic driver that sound awesome",
  },
  {
    type: "Hardware",
    subCategory: "Headphones",
    name: "Sony WH-1000XM4",
    spec: "Noise Cancelling Over the Ear Headphones",
  },
  {
    type: "Hardware",
    subCategory: "Earphones",
    name: "Apple AirPods Pro",
    spec: "AirPods Pro 1st Gen",
    text: "When I got the AirPods, I didn't know it was going to be such a boost to convenience. Coupled with my Macbook, this probably is the best earphones to join a call anytime from anywhere.",
  },
  {
    type: "Hardware",
    subCategory: "Speaker",
    name: "Google Nest Audio",
    spec: "Smart Speaker.",
  },
  {
    type: "Software",
    subCategory: "OS",
    name: "Arch Linux",
    spec: "i3 gaps. Picom. Rofi. Polybar. Termite. ZSH.",
  },
  {
    type: "Software",
    subCategory: "Editor",
    name: "VSCode",
    spec: "Dark Horizon Theme. Material Icon Theme as Icon Pack.",
  },
  {
    type: "Software",
    subCategory: "Extras",
    name: "Other tools",
    spec: "Spotify. Chrome. Google Keep.",
  },
];

export default thingList;
